import { render, staticRenderFns } from "./InsurancePopup.vue?vue&type=template&id=2aff9603&scoped=true"
import script from "./InsurancePopup.vue?vue&type=script&lang=js"
export * from "./InsurancePopup.vue?vue&type=script&lang=js"
import style0 from "./InsurancePopup.vue?vue&type=style&index=0&id=2aff9603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff9603",
  null
  
)

export default component.exports